import styled from 'styled-components';

import { EmptyStateLayout } from '@xing-com/crate-components-empty-state';
import { spaceL, space4XL, scale370 } from '@xing-com/tokens';

export const StyledEmptyStateLayout = styled(EmptyStateLayout)`
  padding: ${space4XL} ${spaceL} ${space4XL};
  min-height: 0;

  & p {
    max-width: ${scale370};
  }
`;
